export const translations = {
  // Finnish (Default)
  fi: {
    // Navigation
    nav: {
      home: 'Etusivu',
      menu: 'Menu',
      reservations: 'Varaukset',
      about: 'Meistä',
      contact: 'Yhteystiedot',
      call: 'Soita',
      whatsapp: 'WhatsApp Chat'
    },
    
    // Homepage
    homepage: {
      welcome: 'Tervetuloa',
      restaurantName: 'Sunsari Restaurant',
      tagline: 'Aitoja makuja • Vuodesta 2019',
      description: 'Koe aitoja makuja Vaasan sydämessä • Vuodesta 2019',
      reserveTable: 'VARAA PÖYTÄ',
      watchMenu: 'Katso Menu',
      viewMenu: 'KATSO MENU',
      
      // Our Story
      ourStory: 'Meidän Tarinamme',
      creating: 'Luomme',
      memorable: 'Unohtumattomia',
      experiences: 'Elämyksiä',
      storyDescription: 'Sunsarissa uskomme, että jokaisen aterian tulisi olla poikkeuksellinen matka. Intohimoiset kokkimme yhdistävät perinteiset tekniikat moderniin innovaatioon luoden ruokia, jotka juhlistavat sekä perintöä että luovuutta.',
      yearsExperience: 'Vuotta Kokemusta',
      signatureDishes: 'Erikoisruokaa',
      authenticAmbiance: 'Aito Tunnelma',
      ambanceDescription: 'Missä perinne kohtaa modernin mukavuuden',
      
      // Experience Sunsari
      experienceSunsari: 'Koe Sunsari',
      galleryInstructions: 'Vedä vierittääksesi • Pysäytä viemällä hiiri • Nopea ääretön silmukka',
      
      // Signature Creations  
      ourSpecialties: 'Meidän Erikoisuudet',
      signatureCreations: 'Erikois Luomukset',
      signature: 'Erikois',
      
      // Today's Menu
      dailyFresh: 'Päivittäin Tuoretta',
      todaysLunch: 'Päivän Lounas',
      lunchBuffet: 'Lounasbuffet',
      lunchDescription: 'Tuoreita päivittäisiä valintoja valmistettu aidoilla mausteilla ja hienoimmilla ainesosilla',
      lunchPrice: 'Lounasbuffet - 14,00€',
      allYouCanEat: 'All-you-can-eat buffet päivän tuoreilla valinnoilla',
      servedWith: 'Tarjoillaan riisin, naan-leivän, salaatin ja juomien kanssa • Ma-Pe 11:00-15:00, La 12:00-16:00',
      viewFullMenu: 'Katso Koko Menu & À la Carte',

      // Catering Services
      cateringServices: 'Pitopalvelu',
      cateringTitle: 'Erikois',
      cateringSubtitle: 'Pitopalvelu',
      cateringDescription: 'Tee tapahtumastasi unohtumaton aitojenmakujemme ja ammattitaitoisen palvelumme avulla. Tarjoamme pitopalvelua kaikentyyppisiin tilaisuuksiin.',
      corporateEvents: 'Yritystapahtumat',
      corporateDescription: 'Kokouseväät, lanseeraukset ja yrityslomunsit',
      privateParties: 'Yksityistilaisuudet',
      privateDescription: 'Syntymäpäivät, häät ja perhejuhlat',
      specialEvents: 'Erikoistapahtumat',
      specialDescription: 'Festivaalit, markkinat ja ulkotapahtumat',
      contactEnquiry: 'Ota Yhteyttä',
      
      // CTA Section
      readyToTaste: 'Valmis',
      tasteExcellence: 'Maistamaan Erinomaisuutta?',
      ctaDescription: 'Liity tuhansiin tyytyväisiin asiakkaisiin, jotka ovat tehneet Sunsarista suosikkiravintolansa',
      bookNow: 'Varaa Pöytäsi Nyt',
      contactUs: 'Ota Yhteyttä',
      
      // Footer
      footerDescription: 'Aitoja makuja Vaasan sydämessä vuodesta 2019. Luomme unohtumattomia ruokailuelämyksiä intohimolla ja perinteellä.',
      quickLinks: 'Pikalinkit',
      followUs: 'Seuraa Meitä',
      address: 'Hietasaarenkatu 18, 65100 Vaasa',
      phone: '+358 40 377 9200',
      email: 'ravintolasunsari@gmail.com',
      copyright: '© 2024 Sunsari Restaurant. Kaikki oikeudet pidätetään.',
      backToTop: 'Takaisin ylös',
      
      // Catering Section
      cateringTitle: 'Ammattimaiset Catering-palvelut',
      cateringSubtitle: 'Aitoa nepalilaista ja intialaista makua erityistilaisuuksiinne',
      
      // Sauce Guide Section  
      sauceGuideTitle: 'Omat Kastikkeet',
      sauceGuideSubtitle: 'Käsintehtyjä perinteisillä mausteilla ja tuoreilla ainesosilla',
      butterSauce: 'Voikastike',
      butterSauceDesc: 'Kermainen tomaatti-cashewpähkinäkastike rikastettuna voilla ja perinteisillä mausteilla',
      butterSaucePopular: 'Suosittu: Butter Chicken, Paneer Butter Masala',
      kormaSauce: 'Korma-kastike',
      kormaSauceDesc: 'Rikas ja mieto cashew-kermakastike, täydellinen niille jotka suosivat lempeämpiä makuja',
      kormaSaucePopular: 'Suosittu: Chicken Korma, Vegetable Korma',
      masalaSauce: 'Masala-kastike',
      masalaSauceDesc: 'Aromikas sipuli-tomaattikastike garam masalalla, jeera-jauheella ja aidolla maustesekoituksella',
      masalaSaucePopular: 'Suosittu: Tikka Masala, Paneer Masala',
      currySauce: 'Curry-kastike',
      currySauceDesc: 'Hienoksi jauhettu sipuli-tomaattikastike curry-jauheella, jeeralla, korianterilla ja raakalla mausteella',
      currySaucePopular: 'Suosittu: Lamb Curry, Chicken Curry',
      tomatoChilli: 'Tomaatti Chilli',
      tomatoChilliDesc: 'Rohkea tomaattikastike soijakastikkeen ja tulisten mausteiden kanssa lämmönystäville',
      tomatoChilliPopular: 'Suosittu: Chilli Chicken, Tuliseen Erikoisuuksien',
      spinachSauce: 'Pinaattikastike',
      spinachSauceDesc: 'Tuore jauhettu pinaatti sekoitettuna aromaattisiin mausteisiin, terveellinen ja maukas',
      spinachSaucePopular: 'Suosittu: Palak Paneer, Saag Chicken',
      cateringCorporate: 'Yritystapahtum',
      cateringCorporateDesc: 'Liikekokous, konferenssit, tuotelanseeraukset ja yrityslounaissa ammattimaisella palvelulla',
      cateringPrivate: 'Yksityisjuhlat',
      cateringPrivateDesc: 'Syntymäpäivät, häät, vuosipäivät ja perhejuhlat aidoilla mauilla',
      cateringSpecial: 'Erikoistapahtumat',
      cateringSpecialDesc: 'Festivaalit, markkinat, ulkotapahtumat ja suuret kokoontumiset joustavilla menu-vaihtoehdoilla',
      
      // Hero Section
      heroWelcome: 'Tervetuloa Sunsariin',
      heroCraft: 'Valmistamme kaiken alusta lähtien omassa keittiössämme',
      orderNow: 'Tilaa Nyt',
      reserveTable: 'Varaa Pöytä',
      alaCarteMenu: 'À la Carte -menu',
      catering: 'Catering-palvelut',
      
      // Fresh Products Section
      freshProductsTitle: 'Omat Tuoreet Tuotteet',
      naanBread: 'Naan-leipä',
      freshBaked: 'Tuore paistettu',
      sauces: '6 Kastiketta',
      dailyGround: 'Päivittäin jauhettu',
      paneer: 'Paneer',
      homemade: 'Kotitekoiset',
      yogurt: 'Jogurtti',
      traditional: 'Perinteinen',
      grilledMeats: 'Grillatut Lihat',
      marinated: 'Marinoitu',
      meatballs: 'Lihapullat',
      handRolled: 'Käsin rullat',
      mayonnaise: 'Majoneesi',
      fresh: 'Tuore'
    },
    
    // Menu Page
    menuPage: {
      ourMenu: 'Meidän Menu',
      description: 'Aitoja makuja luotu intohimolla ja perinteellä',
      dailyLunchMenu: 'Päivittäinen Lounasmenu',
      alaCarteMenu: 'À la Carte Menu',
      freshMealsDaily: 'Tuoreita ja herkullisia aterioita tarjoillaan päivittäin 11:00 - 15:00 (Viikonloppu: 12:00 - 16:00)',
      weekday: 'Arkipäivä',
      weekend: 'Viikonloppu',
      regular: 'Tavallinen: 14,00€',
      weekendRegular: 'Tavallinen: 18,50€',
      pensioner: 'Eläkeläinen: 13,20€',
      student: 'Opiskelija: 13,50€',
      weekendPensioner: 'Eläkeläinen: 17,80€',
      weekendStudent: 'Opiskelija: 18,00€',
      days: {
        monday: 'Maanantai',
        tuesday: 'Tiistai', 
        wednesday: 'Keskiviikko',
        thursday: 'Torstai',
        friday: 'Perjantai',
        weekendSpecial: 'Lauantai Viikonloppu Buffet'
      }
    },
    
    // Reservation Page
    reservationPage: {
      reserveTable: 'VARAA PÖYTÄSI',
      makeReservation: 'Tee Varaus',
      description: 'Varaa pöytäsi Sunsari Restaurantista poikkeuksellista ruokailuelämystä varten. Odotamme innolla tervetulotoivotuksia.',
      reservationDetails: 'Varauksen Tiedot',
      mealType: 'Aterian Tyyppi',
      lunch: 'Lounas',
      dinner: 'Illallinen',
      selectDate: 'Valitse Päivämäärä',
      availableTimes: 'Saatavilla olevat ajat',
      selectTime: 'Valitse aika',
      partySize: 'Seurueen koko',
      guests: 'vierasta',
      guestDetails: 'Asiakkaan Tiedot',
      fullName: 'Koko nimi',
      enterName: 'Syötä koko nimesi',
      email: 'Sähköposti',
      enterEmail: 'Syötä sähköpostiosoitteesi',
      phone: 'Puhelinnumero',
      enterPhone: '+358 40 123 4567',
      makeReservationBtn: 'TEE VARAUS',
      address: 'Osoite',
      openingHours: 'Aukioloajat',
      hours: {
        monday: 'Maanantai: 11:00-15:00',
        tuesday: 'Tiistai-Torstai: 11:00-21:00', 
        friday: 'Perjantai: 11:00-22:00',
        saturday: 'Lauantai: 12:00-22:00',
        sunday: 'Sunnuntai: 12:00-20:00'
      },
      successMessage: '🎉 Varaus lähetetty onnistuneesti! Vahvistamme varauksesi 24 tunnin sisällä sähköpostitse tai puhelimitse. Kiitos että valitsit Sunsarin!'
    },
    
    // Order Page
    orderPage: {
      title: 'Tilaa Verkossa',
      tagline: 'Aito intialainen ja nepalilainen keittiö • Toimitetaan kotiovellesi',
      cart: 'Ostoskori',
      freeDelivery: 'Ilmainen Toimitus',
      freeDeliveryDesc: 'Yli 100€ tilauksille',
      fastDelivery: 'Nopea Toimitus',
      fastDeliveryTime: '20-40 minuuttia*',
      easyPayment: 'Helppo Maksu',
      cashOnDelivery: 'Käteinen toimituksessa',
      specialOffersTitle: '🎉 Erikoistarjoukset tulossa pian!',
      specialOffersDesc: 'Pysy kuulolla eksklusiivisista tarjouksista ja kausi kampanjoista',
      loyaltyTitle: 'Liity Kanta-asiakasohjelmaamme!',
      loyaltyDesc: 'Luo tili → Saa 50 bonuspistettä heti! 1€ = 1 piste. 100 pistettä = 5€ alennus.',
      deliveryTimeNote: '* Toimitusaika vaihtelee tilauksen koon ja etäisyyden mukaan. Tarkka toimitusaika vahvistetaan, kun hyväksymme tilauksesi.',
      
      // Order success
      orderSuccess: 'Tilaus tehty onnistuneesti!',
      thankYou: 'Kiitos, että valitsit Sunsari Restaurantin!',
      checkEmail: 'Tarkista sähköpostisi!',
      emailNotifications: {
        confirmed: 'Saat SÄHKÖPOSTIN, kun vahvistamme tilauksesi arvioituna toimitusaikana',
        tracking: 'Sähköposti sisältää SEURANTALINKIN tilauksen tilan seuraamiseksi reaaliajassa',
        driverLeft: 'Toinen sähköposti, kun kuljettaja lähtee tarkalla saapumisajalla'
      },
      paymentCOD: 'Maksu: Käteinen toimituksessa',
      orderMore: 'Tilaa Lisää 🍽️',
      
      // Menu
      ourMenu: 'Meidän Menu',
      minimumOrder: 'Minimitilaus 16€ • Ilmainen toimitus yli 100€',
      
      // Checkout
      checkout: 'Kassa',
      yourOrder: 'Tilauksesi',
      customerInfo: 'Asiakastiedot',
      name: 'Nimi',
      phone: 'Puhelinnumero',
      email: 'Sähköposti',
      emailRequired: 'Sähköposti (Pakollinen tilausten päivityksille)',
      emailPlaceholder: 'sinun.email@esimerkki.fi',
      emailNote: 'Saat tilausten päivitykset ja seurantalinkin sähköpostitse',
      address: 'Toimitusosoite',
      distance: 'Etäisyys ravintolasta (km)',
      specialInstructions: 'Erityisohjeet',
      specialInstructionsPlaceholder: 'Lisätietoja tilauksestasi...',
      paymentMethod: 'Maksutapa',
      cash: 'Käteinen',
      mobilePay: 'MobilePay',
      card: 'Kortti',
      
      // Cart
      item: 'Tuote',
      quantity: 'Määrä',
      price: 'Hinta',
      total: 'Yhteensä',
      subtotal: 'Välisumma',
      deliveryFee: 'Toimituskulut',
      freeOver100: 'ILMAINEN yli 100€',
      continueToCheckout: 'Jatka kassalle',
      placeOrder: 'Tee tilaus',
      
      // Delivery Info
      deliveryInfo: 'Toimitus tiedot',
      minimumOrderAmount: 'Minimitilaus',
      deliveryFeeInfo: 'Toimituskulut',
      deliveryFeeDetails: '5€ (10€ jos >7km)',
      freeDeliveryOver: 'ILMAINEN yli 100€',
      deliveryTimeTitle: 'Toimitusaika',
      deliveryTimeVaries: 'Aika vaihtelee tilauksen koon ja etäisyyden mukaan'
    },
    
    // About Page
    aboutPage: {
      about: 'Tietoa',
      sunsari: 'Sunsari',
      subtitle: 'Kulinaarinen matka, joka alkoi intohimosta ja jatkuu erinomaisuudella',
      ourJourney: 'MEIDÄN MATKA',
      since2019: 'Vuodesta 2019',
      journeyDescription: 'Vuodesta 2019 lähtien Sunsari on ollut Vaasan kulinaarisen maiseman kulmakivi. Meidän tarinামme alkoi yksinkertaisesta visiosta: tuoda aitoja, perinteisiä makuja moderniin ympäristöön.',
      ourMission: 'MEIDÄN TEHTÄVÄ',
      authenticCuisine: 'Aito Keittiö',
      missionDescription: 'Sunsarissa uskomme ruoan voimaan yhdistää ihmisiä ja luoda unohtumattomia muistoja. Jokainen ruoka valmistetaan huolellisesti käyttäen tuoreimpia ainesosia ja perinteisiä tekniikoita.',
      experience: 'Kokemus',
      loyalCustomers: 'Uskollista Asiakasta',
      awards: 'Palkintoja',
      chefExpertise: 'KOKKI ASIANTUNTEMUS',
      masterChef: 'Mestarikokki',
      chefDescription: 'Johtava kokkimme tuo yli vuosikymmenen kokemuksen autenttisesta keittiöstä.',
      chefRaj: 'Kokki Raj Adhikari',
      rajDescription: 'Erikoistunut perinteisiin ruoanvalmistustekniikoihin ja moderniin fuusioon.'
    },
    
    // Contact Page
    contactPage: {
      getInTouch: 'OTA YHTEYTTÄ',
      contact: 'Ota yhteyttä',
      sunsari: 'Sunsari',
      description: 'Haluaisimme kuulla sinusta. Ota yhteyttä varauksiin, kyselyihin tai vain tervehtiäksesi.',
      visitRestaurant: 'Vieraile Ravintolassamme',
      locationDescription: 'Kulinaarisen alueen sydämessä sijaitseva Sunsari tarjoaa elegantin ruokailuympäristön täydelliselle tilaisuudelle. Tule kokemaan palkittua keittiötämme ympäristössä, joka on suunniteltu unohtumattomia hetkiä varten.',
      address: 'Osoite',
      phone: 'Puhelin',
      sendMessage: 'Lähetä meille Viesti',
      fullName: 'Koko nimi',
      enterFullName: 'Syötä koko nimesi',
      email: 'Sähköposti',
      enterEmail: 'sinun@sähköposti.com',
      phoneNumber: 'Puhelinnumero',
      enterPhone: '+358 40 123 4567',
      subject: 'Aihe',
      selectSubject: 'Valitse aihe',
      subjects: {
        general: 'Yleinen kysely',
        reservation: 'Varaus',
        event: 'Yksityinen tapahtuma',
        complaint: 'Valitus',
        compliment: 'Kohteliaisuus'
      },
      message: 'Viesti',
      enterMessage: 'Syötä viestisi tähän...',
      sendBtn: 'LÄHETÄ VIESTI',
      hours: 'Tunnit'
    },
    
    // Admin Panel
    adminPanel: {
      adminPanel: 'Hallintapaneeli',
      management: 'Sunsari Restaurant Hallinta',
      contentManagement: 'Sisällönhallinta',
      manageItems: 'Hallitse menu-kohteita ja kuvia',
      backToWebsite: 'Takaisin Verkkosivulle'
    },
    
    // Common
    common: {
      loading: 'Ladataan...',
      error: 'Virhe',
      success: 'Onnistui',
      popular: 'Suosittu',
      vegan: 'Vegaani',
      spicy: 'Tulinen',
      new: 'Uusi'
    }
  },
  
  // English
  en: {
    // Navigation
    nav: {
      home: 'Home',
      menu: 'Menu', 
      reservations: 'Reservations',
      about: 'About',
      contact: 'Contact',
      call: 'Call',
      whatsapp: 'WhatsApp Chat'
    },
    
    // Homepage
    homepage: {
      welcome: 'Welcome to',
      restaurantName: 'Sunsari Restaurant',
      tagline: 'Authentic Flavors • Since 2019',
      description: 'Experience authentic flavors in the heart of Vaasa • Since 2019',
      reserveTable: 'RESERVE TABLE',
      watchMenu: 'WATCH MENU',
      viewMenu: 'VIEW MENU',
      
      // Our Story
      ourStory: 'Our Story',
      creating: 'Creating',
      memorable: 'Memorable',
      experiences: 'Experiences',
      storyDescription: 'At Sunsari, we believe every meal should be an extraordinary journey. Our passionate chefs blend traditional techniques with modern innovation, creating dishes that celebrate both heritage and creativity.',
      yearsExperience: 'Years Experience',
      signatureDishes: 'Signature Dishes',
      authenticAmbiance: 'Authentic Ambiance',
      ambanceDescription: 'Where tradition meets modern comfort',
      
      // Experience Sunsari
      experienceSunsari: 'Experience Sunsari',
      galleryInstructions: 'Drag to scroll • Hover to pause • Fast infinite loop',
      
      // Signature Creations
      ourSpecialties: 'Our Specialties',
      signatureCreations: 'Signature Creations',
      signature: 'Signature',
      
      // Today's Menu
      dailyFresh: 'Daily Fresh',
      todaysLunch: "Today's Lunch",
      lunchBuffet: 'Lunch Buffet',
      lunchDescription: 'Fresh daily selections prepared with authentic spices and the finest ingredients',
      lunchPrice: 'Lunch Buffet - 14,00€',
      allYouCanEat: 'All-you-can-eat buffet with today\'s fresh selections',
      servedWith: 'Served with rice, naan bread, salad, and beverages • Mon-Fri 11:00-15:00, Sat 12:00-16:00',
      viewFullMenu: 'View Full Menu & À la Carte',

      // Catering Services
      cateringServices: 'Catering Services',
      cateringTitle: 'Special',
      cateringSubtitle: 'Catering',
      cateringDescription: 'Make your event unforgettable with our authentic flavors and professional service. We cater to all types of occasions.',
      corporateEvents: 'Corporate Events',
      corporateDescription: 'Business meetings, launches and corporate lunches',
      privateParties: 'Private Parties',
      privateDescription: 'Birthdays, weddings and family celebrations',
      specialEvents: 'Special Events',
      specialDescription: 'Festivals, markets and outdoor events',
      contactEnquiry: 'Contact Enquiry',
      
      // CTA Section
      readyToTaste: 'Ready to',
      tasteExcellence: 'Taste Excellence?',
      ctaDescription: 'Join thousands of satisfied customers who have made Sunsari their favorite dining destination',
      bookNow: 'Book Your Table Now',
      contactUs: 'Contact Us',
      
      // Catering Section
      cateringTitle: 'Professional Catering Services',
      cateringSubtitle: 'Authentic Nepalese and Indian flavours for your special events',
      cateringCorporate: 'Corporate Events',
      cateringCorporateDesc: 'Business meetings, conferences, product launches, and corporate lunches with professional service',
      cateringPrivate: 'Private Parties',
      cateringPrivateDesc: 'Birthdays, weddings, anniversaries, and family celebrations with authentic flavors',
      cateringSpecial: 'Special Events',
      cateringSpecialDesc: 'Festivals, markets, outdoor events, and large gatherings with flexible menu options',
      
      // Hero Section
      heroWelcome: 'Welcome to Sunsari',
      heroCraft: 'We craft everything from scratch in our kitchen',
      orderNow: 'Order Now',
      reserveTable: 'Reserve Table',
      alaCarteMenu: 'À la Carte Menu',
      catering: 'Catering Services',
      
      // Fresh Products Section
      freshProductsTitle: 'Our Own Fresh Products',
      naanBread: 'Naan Bread',
      freshBaked: 'Fresh baked',
      sauces: '6 Sauces',
      dailyGround: 'Daily ground',
      paneer: 'Paneer',
      homemade: 'Homemade',
      yogurt: 'Yogurt',
      traditional: 'Traditional',
      grilledMeats: 'Grilled Meats',
      marinated: 'Marinated',
      meatballs: 'Meatballs',
      handRolled: 'Hand-rolled',
      mayonnaise: 'Mayonnaise',
      fresh: 'Fresh',
      
      // Footer
      footerDescription: 'Authentic flavors in the heart of Vaasa since 2019. Creating memorable dining experiences with passion and tradition.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      address: 'Hietasaarenkatu 18, 65100 Vaasa',
      phone: '+358 40 377 9200',
      email: 'ravintolasunsari@gmail.com',
      copyright: '© 2024 Sunsari Restaurant. All rights reserved.',
      backToTop: 'Go to Top',
    },
    
    // Menu Page
    menuPage: {
      ourMenu: 'Our Menu',
      description: 'Authentic flavors crafted with passion and tradition',
      dailyLunchMenu: 'Daily Lunch Menu',
      alaCarteMenu: 'À la Carte Menu',
      freshMealsDaily: 'Fresh and delicious meals served daily from 11 AM - 3 PM (Weekend: 12 PM - 4 PM)',
      weekday: 'Weekday',
      weekend: 'Weekend',
      regular: 'Regular: 14,00€',
      weekendRegular: 'Regular: 18,50€',
      pensioner: 'Pensioner: 13,20€',
      student: 'Student: 13,50€',
      weekendPensioner: 'Pensioner: 17,80€',
      weekendStudent: 'Student: 18,00€',
      days: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday', 
        thursday: 'Thursday',
        friday: 'Friday',
        weekendSpecial: 'Saturday Weekend Buffet'
      }
    },
    
    // Reservation Page
    reservationPage: {
      reserveTable: 'RESERVE YOUR TABLE',
      makeReservation: 'Make a Reservation',
      description: 'Reserve your table at Sunsari Restaurant for an exceptional dining experience. We look forward to welcoming you.',
      reservationDetails: 'Reservation Details',
      mealType: 'Meal Type',
      lunch: 'Lunch',
      dinner: 'Dinner',
      selectDate: 'Select Date',
      availableTimes: 'Available Times for',
      selectTime: 'Select time',
      partySize: 'Party Size',
      guests: 'guests',
      guestDetails: 'Guest Details',
      fullName: 'Full Name',
      enterName: 'Enter your full name',
      email: 'Email',
      enterEmail: 'Enter your email address',
      phone: 'Phone Number',
      enterPhone: '+358 40 123 4567',
      makeReservationBtn: 'MAKE RESERVATION',
      address: 'Address',
      openingHours: 'Opening Hours',
      hours: {
        monday: 'Monday: 11:00-15:00',
        tuesday: 'Tuesday-Thursday: 11:00-21:00',
        friday: 'Friday: 11:00-22:00',
        saturday: 'Saturday: 12:00-22:00',
        sunday: 'Sunday: 12:00-20:00'
      },
      successMessage: '🎉 Reservation request sent successfully! We will confirm your booking within 24 hours via email or phone. Thank you for choosing Sunsari!'
    },
    
    // Order Page
    orderPage: {
      title: 'Order Online',
      tagline: 'Authentic Indian & Nepalese Cuisine • Delivered to Your Door',
      cart: 'Cart',
      freeDelivery: 'Free Delivery',
      freeDeliveryDesc: 'Orders over 100€',
      fastDelivery: 'Fast Delivery',
      fastDeliveryTime: '20-40 minutes*',
      easyPayment: 'Easy Payment',
      cashOnDelivery: 'Cash on Delivery',
      specialOffersTitle: '🎉 Special Offers Coming Soon!',
      specialOffersDesc: 'Stay tuned for exclusive deals and seasonal promotions',
      loyaltyTitle: 'Join Our Loyalty Program!',
      loyaltyDesc: 'Create account → Get 50 bonus points! Earn 1 pt per €1. Redeem 100 pts = €5 off.',
      deliveryTimeNote: '* Delivery time varies based on order size and distance. Exact delivery time will be confirmed when we accept your order.',
      
      // Order success
      orderSuccess: 'Order Placed Successfully!',
      thankYou: 'Thank you for choosing Sunsari Restaurant!',
      checkEmail: 'Check Your Email!',
      emailNotifications: {
        confirmed: 'You\'ll receive an EMAIL when we confirm your order with estimated delivery time',
        tracking: 'Email includes a TRACKING LINK to follow your order status in real-time',
        driverLeft: 'Another email when driver leaves with exact arrival time'
      },
      paymentCOD: 'Payment: Cash on Delivery',
      orderMore: 'Order More 🍽️',
      
      // Menu
      ourMenu: 'Our Menu',
      minimumOrder: 'Minimum order 16€ • Free delivery over 100€',
      
      // Checkout
      checkout: 'Checkout',
      yourOrder: 'Your Order',
      customerInfo: 'Customer Information',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      emailRequired: 'Email (Required for order updates)',
      emailPlaceholder: 'your.email@example.com',
      emailNote: 'You\'ll receive order updates and tracking link via email',
      address: 'Delivery Address',
      distance: 'Distance from Restaurant (km)',
      specialInstructions: 'Special Instructions',
      specialInstructionsPlaceholder: 'Any special requests for your order...',
      paymentMethod: 'Payment Method',
      cash: 'Cash',
      mobilePay: 'MobilePay',
      card: 'Card',
      
      // Cart
      item: 'Item',
      quantity: 'Quantity',
      price: 'Price',
      total: 'Total',
      subtotal: 'Subtotal',
      deliveryFee: 'Delivery Fee',
      freeOver100: 'FREE over 100€',
      continueToCheckout: 'Continue to Checkout',
      placeOrder: 'Place Order',
      
      // Delivery Info
      deliveryInfo: 'Delivery Information',
      minimumOrderAmount: 'Minimum Order',
      deliveryFeeInfo: 'Delivery Fee',
      deliveryFeeDetails: '5€ (10€ if >7km)',
      freeDeliveryOver: 'FREE over 100€',
      deliveryTimeTitle: 'Delivery Time',
      deliveryTimeVaries: 'Time varies by order size & distance'
    },
    
    // About Page
    aboutPage: {
      about: 'About',
      sunsari: 'Sunsari',
      subtitle: 'A culinary journey that began with passion and continues with excellence',
      ourJourney: 'OUR JOURNEY',
      since2019: 'Since 2019',
      journeyDescription: 'Since 2019, Sunsari has been a cornerstone of Vaasa\'s culinary landscape. Our story began with a simple vision: to bring authentic, traditional flavors to a modern setting.',
      ourMission: 'OUR MISSION',
      authenticCuisine: 'Authentic Cuisine',
      missionDescription: 'At Sunsari, we believe in the power of food to bring people together and create unforgettable memories. Every dish is crafted with care, using the freshest ingredients and traditional techniques.',
      experience: 'Years Experience',
      loyalCustomers: 'Loyal Customers',
      awards: 'Awards Won',
      chefExpertise: 'CHEF EXPERTISE',
      masterChef: 'Master Chef',
      chefDescription: 'Our head chef brings over a decade of experience in authentic cuisine.',
      chefRaj: 'Chef Raj Adhikari',
      rajDescription: 'Specializing in traditional cooking techniques and modern fusion.'
    },
    
    // Contact Page
    contactPage: {
      getInTouch: 'GET IN TOUCH',
      contact: 'Contact',
      sunsari: 'Sunsari',
      description: 'We\'d love to hear from you. Reach out for reservations, inquiries, or just to say hello.',
      visitRestaurant: 'Visit Our Restaurant',
      locationDescription: 'Located in the heart of the culinary district, Sunsari offers an elegant dining atmosphere perfect for any occasion. Come experience our award-winning cuisine in a setting designed for memorable moments.',
      address: 'Address',
      phone: 'Phone',
      sendMessage: 'Send us a Message',
      fullName: 'Full Name',
      enterFullName: 'Your full name',
      email: 'Email',
      enterEmail: 'your@email.com',
      phoneNumber: 'Phone',
      enterPhone: '+358 40 123 4567',
      subject: 'Subject',
      selectSubject: 'Select a subject',
      subjects: {
        general: 'General Inquiry',
        reservation: 'Reservation',
        event: 'Private Event',
        complaint: 'Complaint',
        compliment: 'Compliment'
      },
      message: 'Message',
      enterMessage: 'Enter your message here...',
      sendBtn: 'SEND MESSAGE',
      hours: 'Hours'
    },
    
    // Admin Panel
    adminPanel: {
      adminPanel: 'Admin Panel',
      management: 'Sunsari Restaurant Management',
      contentManagement: 'Content Management',
      manageItems: 'Manage menu items and photos',
      backToWebsite: 'Back to Website'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      popular: 'Popular',
      vegan: 'Vegan',
      spicy: 'Spicy',
      new: 'New'
    }
  },
  
  // Swedish
  sv: {
    // Navigation
    nav: {
      home: 'Hem',
      menu: 'Meny',
      reservations: 'Reservationer',
      about: 'Om oss',
      contact: 'Kontakt',
      call: 'Ring',
      whatsapp: 'WhatsApp Chat'
    },
    
    // Homepage
    homepage: {
      welcome: 'Välkommen till',
      restaurantName: 'Sunsari Restaurant',
      tagline: 'Autentiska smaker • Sedan 2019',
      description: 'Upplev autentiska smaker i hjärtat av Vasa • Sedan 2019',
      reserveTable: 'RESERVERA BORD',
      watchMenu: 'TITTA MENY',
      viewMenu: 'SE MENY',
      
      // Our Story
      ourStory: 'Vår Berättelse',
      creating: 'Skapar',
      memorable: 'Minnesvärda',
      experiences: 'Upplevelser',
      storyDescription: 'På Sunsari tror vi att varje måltid ska vara en extraordinär resa. Våra passionerade kockar blandar traditionella tekniker med modern innovation och skapar rätter som firar både arv och kreativitet.',
      yearsExperience: 'År Erfarenhet',
      signatureDishes: 'Signaturrätter',
      authenticAmbiance: 'Autentisk Atmosfär',
      ambanceDescription: 'Där tradition möter modern komfort',
      
      // Experience Sunsari
      experienceSunsari: 'Upplev Sunsari',
      galleryInstructions: 'Dra för att scrolla • Hovra för att pausa • Snabb oändlig loop',
      
      // Signature Creations
      ourSpecialties: 'Våra Specialiteter',
      signatureCreations: 'Signaturskapelser',
      signature: 'Signatur',
      
      // Today's Menu
      dailyFresh: 'Dagligen Färskt',
      todaysLunch: 'Dagens Lunch',
      lunchBuffet: 'Lunchbuffé',
      lunchDescription: 'Färska dagliga val tillagade med autentiska kryddor och de finaste ingredienserna',
      lunchPrice: 'Lunchbuffé - 14,00€',
      allYouCanEat: 'Äta-så-mycket-du-vill buffé med dagens färska val',
      servedWith: 'Serveras med ris, naan-bröd, sallad och drycker • Mån-Fre 11:00-15:00, Lör 12:00-16:00',
      viewFullMenu: 'Se Hela Menyn & À la Carte',

      // Catering Services
      cateringServices: 'Cateringtjänster',
      cateringTitle: 'Special',
      cateringSubtitle: 'Catering',
      cateringDescription: 'Gör ditt evenemang oförglömligt med våra autentiska smaker och professionella service. Vi cateringger alla typer av tillfällen.',
      corporateEvents: 'Företagsevenemang',
      corporateDescription: 'Affärsmöten, lansering och företagsluncher',
      privateParties: 'Privata Fester',
      privateDescription: 'Födelsedagar, bröllop och familjehelger',
      specialEvents: 'Specialevenemang',
      specialDescription: 'Festivaler, marknader och utomhusevenemang',
      contactEnquiry: 'Kontakta Förfrågan',
      
      // CTA Section
      readyToTaste: 'Redo att',
      tasteExcellence: 'Smaka Excellens?',
      ctaDescription: 'Anslut dig till tusentals nöjda kunder som har gjort Sunsari till sin favoritrestaurang',
      bookNow: 'Boka Ditt Bord Nu',
      contactUs: 'Kontakta Oss',
      
      // Catering Section
      cateringTitle: 'Professionella Cateringtjänster',
      cateringSubtitle: 'Autentiska nepalesiska och indiska smaker för era speciella evenemang',
      cateringCorporate: 'Företagsevenemang',
      cateringCorporateDesc: 'Affärsmöten, konferenser, produktlanseringar och företagsluncher med professionell service',
      cateringPrivate: 'Privata fester',
      cateringPrivateDesc: 'Födelsedagar, bröllop, jubileer och familjefiranden med autentiska smakerletion',
      cateringSpecial: 'Specialevenemang',
      cateringSpecialDesc: 'Festivaler, marknader, utomhusevenemang och stora sammankomster med flexibla menyalternativ',
      
      // Hero Section
      heroWelcome: 'Välkommen till Sunsari',
      heroCraft: 'Vi lagar allt från grunden i vårt kök',
      orderNow: 'Beställ Nu',
      reserveTable: 'Boka Bord',
      alaCarteMenu: 'À la Carte-meny',
      catering: 'Cateringtjänster',
      
      // Fresh Products Section
      freshProductsTitle: 'Våra Egna Färska Produkter',
      naanBread: 'Naan-bröd',
      freshBaked: 'Färskt bakat',
      sauces: '6 Såser',
      dailyGround: 'Dagligen malt',
      paneer: 'Paneer',
      homemade: 'Hemgjord',
      yogurt: 'Yoghurt',
      traditional: 'Traditionell',
      grilledMeats: 'Grillat Kött',
      marinated: 'Marinerad',
      meatballs: 'Köttbullar',
      handRolled: 'Handrullad',
      mayonnaise: 'Majonnäs',
      fresh: 'Färsk',
      
      // Footer
      footerDescription: 'Autentiska smaker i hjärtat av Vasa sedan 2019. Skapar minnesvärda matupplevelser med passion och tradition.',
      quickLinks: 'Snabblänkar',
      followUs: 'Följ Oss',
      address: 'Hietasaarenkatu 18, 65100 Vasa',
      phone: '+358 40 377 9200',
      email: 'ravintolasunsari@gmail.com',
      copyright: '© 2024 Sunsari Restaurant. Alla rättigheter förbehållna.',
      backToTop: 'Till toppen',
    },
    
    // Menu Page
    menuPage: {
      ourMenu: 'Vår Meny',
      description: 'Autentiska smaker skapade med passion och tradition',
      dailyLunchMenu: 'Daglig Lunchmeny',
      alaCarteMenu: 'À la Carte Meny',
      freshMealsDaily: 'Färska och läckra måltider serveras dagligen 11:00 - 15:00 (Helg: 12:00 - 16:00)',
      weekday: 'Vardag',
      weekend: 'Helg',
      regular: 'Ordinarie: 14,00€',
      weekendRegular: 'Ordinarie: 18,50€',
      pensioner: 'Pensionär: 13,20€',
      student: 'Student: 13,50€',
      weekendPensioner: 'Pensionär: 17,80€',
      weekendStudent: 'Student: 18,00€',
      days: {
        monday: 'Måndag',
        tuesday: 'Tisdag',
        wednesday: 'Onsdag',
        thursday: 'Torsdag', 
        friday: 'Fredag',
        weekendSpecial: 'Lördag Helgbuffé'
      }
    },
    
    // Reservation Page
    reservationPage: {
      reserveTable: 'RESERVERA DITT BORD',
      makeReservation: 'Gör en Reservation',
      description: 'Reservera ditt bord på Sunsari Restaurant för en exceptionell matupplevelse. Vi ser fram emot att välkomna dig.',
      reservationDetails: 'Reservationsdetaljer',
      mealType: 'Måltidstyp',
      lunch: 'Lunch',
      dinner: 'Middag',
      selectDate: 'Välj Datum',
      availableTimes: 'Tillgängliga tider för',
      selectTime: 'Välj tid',
      partySize: 'Sällskapsstorlek',
      guests: 'gäster',
      guestDetails: 'Gästdetaljer',
      fullName: 'Fullständigt Namn',
      enterName: 'Ange ditt fullständiga namn',
      email: 'E-post',
      enterEmail: 'Ange din e-postadress',
      phone: 'Telefonnummer',
      enterPhone: '+358 40 123 4567',
      makeReservationBtn: 'GÖR RESERVATION',
      address: 'Adress',
      openingHours: 'Öppettider',
      hours: {
        monday: 'Måndag: 11:00-15:00',
        tuesday: 'Tisdag-Torsdag: 11:00-21:00',
        friday: 'Fredag: 11:00-22:00',
        saturday: 'Lördag: 12:00-22:00',
        sunday: 'Söndag: 12:00-20:00'
      },
      successMessage: '🎉 Reservationsförfrågan skickad framgångsrikt! Vi kommer att bekräfta din bokning inom 24 timmar via e-post eller telefon. Tack för att du väljer Sunsari!'
    },
    
    // Order Page
    orderPage: {
      title: 'Beställ Online',
      tagline: 'Autentisk indisk & nepalesisk mat • Levereras hem till dig',
      cart: 'Varukorg',
      freeDelivery: 'Fri Leverans',
      freeDeliveryDesc: 'Beställningar över 100€',
      fastDelivery: 'Snabb Leverans',
      fastDeliveryTime: '20-40 minuter*',
      easyPayment: 'Enkel Betalning',
      cashOnDelivery: 'Kontant vid leverans',
      specialOffersTitle: '🎉 Specialerbjudanden kommer snart!',
      specialOffersDesc: 'Håll utkik efter exklusiva erbjudanden och säsongsrean',
      loyaltyTitle: 'Gå med i vårt lojalitetsprogram!',
      loyaltyDesc: 'Skapa konto → Få 50 bonuspoäng! Tjäna 1 pt per €1. Lös in 100 pts = €5 rabatt.',
      deliveryTimeNote: '* Leveranstiden varierar beroende på beställningsstorlek och avstånd. Exakt leveranstid bekräftas när vi accepterar din beställning.',
      
      // Order success
      orderSuccess: 'Beställning genomförd!',
      thankYou: 'Tack för att du väljer Sunsari Restaurant!',
      checkEmail: 'Kontrollera din e-post!',
      emailNotifications: {
        confirmed: 'Du får ett E-POST när vi bekräftar din beställning med uppskattad leveranstid',
        tracking: 'E-posten innehåller en SPÅRNINGSLÄNK för att följa din beställningsstatus i realtid',
        driverLeft: 'Ytterligare e-post när föraren lämnar med exakt ankomsttid'
      },
      paymentCOD: 'Betalning: Kontant vid leverans',
      orderMore: 'Beställ Mer 🍽️',
      
      // Menu
      ourMenu: 'Vår Meny',
      minimumOrder: 'Minimibeställning 16€ • Fri leverans över 100€',
      
      // Checkout
      checkout: 'Kassa',
      yourOrder: 'Din Beställning',
      customerInfo: 'Kundinformation',
      name: 'Namn',
      phone: 'Telefon',
      email: 'E-post',
      emailRequired: 'E-post (Krävs för beställningsuppdateringar)',
      emailPlaceholder: 'din.email@exempel.se',
      emailNote: 'Du får beställningsuppdateringar och spårningslänk via e-post',
      address: 'Leveransadress',
      distance: 'Avstånd från restaurangen (km)',
      specialInstructions: 'Specialinstruktioner',
      specialInstructionsPlaceholder: 'Eventuella specialönskemål för din beställning...',
      paymentMethod: 'Betalningsmetod',
      cash: 'Kontant',
      mobilePay: 'MobilePay',
      card: 'Kort',
      
      // Cart
      item: 'Artikel',
      quantity: 'Antal',
      price: 'Pris',
      total: 'Totalt',
      subtotal: 'Delsumma',
      deliveryFee: 'Leveransavgift',
      freeOver100: 'GRATIS över 100€',
      continueToCheckout: 'Fortsätt till kassan',
      placeOrder: 'Lägg beställning',
      
      // Delivery Info
      deliveryInfo: 'Leveransinformation',
      minimumOrderAmount: 'Minimibeställning',
      deliveryFeeInfo: 'Leveransavgift',
      deliveryFeeDetails: '5€ (10€ om >7km)',
      freeDeliveryOver: 'GRATIS över 100€',
      deliveryTimeTitle: 'Leveranstid',
      deliveryTimeVaries: 'Tiden varierar beroende på beställningsstorlek och avstånd'
    },
    
    // About Page
    aboutPage: {
      about: 'Om',
      sunsari: 'Sunsari',
      subtitle: 'En kulinarisk resa som började med passion och fortsätter med excellens',
      ourJourney: 'VÅR RESA',
      since2019: 'Sedan 2019',
      journeyDescription: 'Sedan 2019 har Sunsari varit en hörnsten i Vasas kulinariska landskap. Vår berättelse började med en enkel vision: att föra autentiska, traditionella smaker till en modern miljö.',
      ourMission: 'VÅRT UPPDRAG',
      authenticCuisine: 'Autentiskt Kök',
      missionDescription: 'På Sunsari tror vi på matens kraft att föra människor samman och skapa oförglömliga minnen. Varje rätt tillagas med omsorg, med de färskaste ingredienserna och traditionella tekniker.',
      experience: 'År Erfarenhet',
      loyalCustomers: 'Lojala Kunder',
      awards: 'Vunna Priser',
      chefExpertise: 'KOCKEXPERTIS',
      masterChef: 'Mästerkock',
      chefDescription: 'Vår huvudkock har över ett decenniums erfarenhet av autentisk matlagning.',
      chefRaj: 'Kock Raj Adhikari',
      rajDescription: 'Specialiserad på traditionella matlagningstekniker och modern fusion.'
    },
    
    // Contact Page
    contactPage: {
      getInTouch: 'KONTAKTA OSS',
      contact: 'Kontakta',
      sunsari: 'Sunsari',
      description: 'Vi skulle gärna höra från dig. Kontakta oss för reservationer, förfrågningar eller bara för att säga hej.',
      visitRestaurant: 'Besök Vår Restaurang',
      locationDescription: 'Belägen i hjärtat av det kulinariska distriktet erbjuder Sunsari en elegant middagsatmosfär perfekt för alla tillfällen. Kom och upplev vårt prisbelönta kök i en miljö designad för minnesvärda stunder.',
      address: 'Adress',
      phone: 'Telefon',
      sendMessage: 'Skicka oss ett Meddelande',
      fullName: 'Fullständigt Namn',
      enterFullName: 'Ditt fullständiga namn',
      email: 'E-post',
      enterEmail: 'din@epost.com',
      phoneNumber: 'Telefon',
      enterPhone: '+358 40 123 4567',
      subject: 'Ämne',
      selectSubject: 'Välj ett ämne',
      subjects: {
        general: 'Allmän förfrågan',
        reservation: 'Reservation',
        event: 'Privat evenemang',
        complaint: 'Klagomål',
        compliment: 'Komplimang'
      },
      message: 'Meddelande',
      enterMessage: 'Skriv ditt meddelande här...',
      sendBtn: 'SKICKA MEDDELANDE',
      hours: 'Timmar'
    },
    
    // Admin Panel
    adminPanel: {
      adminPanel: 'Administratörspanel',
      management: 'Sunsari Restaurant Hantering',
      contentManagement: 'Innehållshantering',
      manageItems: 'Hantera menyobjekt och foton',
      backToWebsite: 'Tillbaka till Webbplats'
    },
    
    // Common
    common: {
      loading: 'Laddar...',
      error: 'Fel',
      success: 'Framgång',
      popular: 'Populär',
      vegan: 'Vegansk',
      spicy: 'Kryddig', 
      new: 'Ny'
    }
  }
};